import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const LeaveReportDialog = ({ 
  open, 
  onClose, 
  onSaveAndLeave, 
  onLeaveWithoutSaving 
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <WarningAmberIcon color="warning" />
        {t('report.leaveDialog.title')}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          {t('report.leaveDialog.message')}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ gap: 1, p: 3 }}>
        <Button
          onClick={onClose}
          className="button-cancel"
          sx={{ minWidth: '140px', minHeight: '50px' }}
        >
          <Box sx={{ textAlign: 'center', lineHeight: 1.2 }}>
            <Typography variant="body2" component="div">
              {t('report.leaveDialog.cancel')}
            </Typography>
          </Box>
        </Button>
        <Button
          onClick={onLeaveWithoutSaving}
          className="button-cancel"
          sx={{ minWidth: '140px', minHeight: '50px' }}
        >
          <Box sx={{ textAlign: 'center', lineHeight: 1.2 }}>
            <Typography variant="body2" component="div">
              {t('report.leaveDialog.leaveWithoutSaving.line1')}
            </Typography>
            <Typography variant="body2" component="div">
              {t('report.leaveDialog.leaveWithoutSaving.line2')}
            </Typography>
          </Box>
        </Button>
        <Button
          onClick={onSaveAndLeave}
          className="button"
          sx={{ minWidth: '140px', minHeight: '50px' }}
        >
          <Box sx={{ textAlign: 'center', lineHeight: 1.2 }}>
            <Typography variant="body2" component="div">
              {t('report.leaveDialog.saveAndLeave.line1')}
            </Typography>
            <Typography variant="body2" component="div">
              {t('report.leaveDialog.saveAndLeave.line2')}
            </Typography>
          </Box>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LeaveReportDialog;
